// src/services/SupabaseKeepAlive.js
// ─────────────────────────────────────────────────────────────────────────────
// Sends a lightweight ping to both Supabase projects on game boot.
// Prevents free-tier projects from being paused due to inactivity (7-day limit).
// Fire-and-forget — never blocks gameplay, errors are silently ignored.
// ─────────────────────────────────────────────────────────────────────────────

const PROJECTS = [
  {
    name: 'CloudSync',
    url:  `${import.meta.env.VITE_SUPABASE_URL}/rest/v1/player_collections?limit=0`,
    key:  import.meta.env.VITE_SUPABASE_ANON_KEY,
  },
  {
    name: 'Leaderboard',
    url:  'https://bnwakofsuhnglavdwmin.supabase.co/rest/v1/challenge_scores?limit=0',
    key:  'sb_publishable_mdJ0aJ7gQhe7ju3m5kr_MA_a55EaJlv',
  },
];

export function pingSupabase() {
  for (const project of PROJECTS) {
    if (!project.url || !project.key) continue;
    fetch(project.url, {
      method:  'GET',
      headers: { 'apikey': project.key, 'Authorization': `Bearer ${project.key}` },
    }).catch(() => {});
  }
}
